export default __webpack_public_path__ + "static/media/ring_light.7906a0af.png";